import React, { createContext, useContext, useState } from "react";
import { strings } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("pt_lang") || "en");

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("pt_lang", l);
  };

  const t = (key) => {
    const entry = strings[key];
    if (!entry) return key;
    return entry[lang] || entry.en || key;
  };

  // pick localized field from a content object: name / name_ms
  const pick = (obj, field) => {
    if (!obj) return "";
    if (lang === "ms") return obj[`${field}_ms`] || obj[field] || "";
    return obj[field] || "";
  };

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
